import King from '@/assets/graphical-elements/king.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const KingIcon = ({className}: IconProps) => <King className={cn('fill-current', className)} />
